import styled from 'styled-components';
import theme from '@/theme';
import type { FC } from 'react';
import { Link } from '@/components/link';

const { LogoInverse } = theme;

export const StyledLogo = styled(LogoInverse)`
  width: 182px;
  height: 56px;
  margin-bottom: 40px ;
`;

export const EnmonLogo: FC = () => {
  return (
    <Link to="/">
      <StyledLogo />
    </Link>
  );
};
